<!-- Impersonation Banner -->
@if (impersonationService.isImpersonating$ | async) {
  <div style="
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    width: 100%;
    padding: 6px 16px;
    background: #e65100;
    color: #fff;
    font-size: 13px;
    font-weight: 500;
    box-sizing: border-box;
  ">
    <mat-icon style="font-size:18px; width:18px; height:18px; line-height:18px;">visibility</mat-icon>
    <span>
      Viewing as <strong>{{ impersonationService.getImpersonatedUser()?.name }}</strong>
      ({{ impersonationService.getImpersonatedUser()?.role }})
    </span>
    <button
      mat-stroked-button
      style="color:#fff; border-color:rgba(255,255,255,0.6); font-size:12px; height:28px; line-height:28px; padding:0 10px;"
      (click)="impersonationService.stopImpersonation()">
      Stop Impersonating
    </button>
  </div>
}

<div class="toolbar w-full px-gutter flex items-center justify-start" vexContainer>
  <!-- Mobile menu button -->
  @if (mobileQuery) {
    <button (click)="openSidenav()" mat-icon-button type="button">
      <iconify-icon class="icon-animate icon-animate-rotate" [icon]="icMenu" width="24" height="24"></iconify-icon>
    </button>
  }

  <!-- Logo -->
  @if ((isVerticalLayout$ | async)) {
    <a
      [routerLink]="['/']"
      class="ltr:mr-4 rtl:ml-4 flex items-center">
      <img class="w-8 select-none" src="assets/img/demo/logo.png" alt="POP Creations Logo">
      @if (!mobileQuery) {
        <h1 class="title ltr:pl-4 rtl:pr-4 m-0 select-none">Designflow</h1>
      }
    </a>
  }

  <!-- Add New Menu -->
  <mat-menu #addNewMenu="matMenu" [overlapTrigger]="false" xPosition="after" yPosition="below">
    <button mat-menu-item>
      <iconify-icon [icon]="icPersonAdd" width="24" height="24"></iconify-icon>
      <span>Add Contact</span>
    </button>
    <button mat-menu-item (click)="openAssignTaskDialog()">
      <iconify-icon [icon]="icDoneAll" width="24" height="24"></iconify-icon>
      <span>Add Task</span>
    </button>
    <button mat-menu-item>
      <iconify-icon [icon]="icAssignmentTurnedIn" width="24" height="24"></iconify-icon>
      <span>Add Project</span>
    </button>
    <button [matMenuTriggerFor]="documentMenu" mat-menu-item>
      <iconify-icon [icon]="icBallot" width="24" height="24"></iconify-icon>
      <span>Add Document</span>
    </button>
  </mat-menu>

  <!-- Document Submenu -->
  <mat-menu #documentMenu="matMenu">
    <button mat-menu-item>
      <iconify-icon [icon]="icDescription" width="24" height="24"></iconify-icon>
      <span>Add Quote</span>
    </button>
    <button mat-menu-item>
      <iconify-icon [icon]="icAssignment" width="24" height="24"></iconify-icon>
      <span>Add Invoice</span>
    </button>
    <button mat-menu-item>
      <iconify-icon [icon]="icReceipt" width="24" height="24"></iconify-icon>
      <span>Add Receipt</span>
    </button>
  </mat-menu>

  <!-- Mega Menu -->
  <div style="visibility: hidden;" #megaMenuOriginRef class="ltr:ml-2 rtl:mr-2">
    @if ((isHorizontalLayout$ | async) && !mobileQuery) {
      <button
        (click)="openMegaMenu(megaMenuOriginRef)"
        color="primary"
        mat-button
        type="button">
        MEGA MENU
        <ic-icon [icon]="icArrowDropDown" class="ltr:-mr-1 rtl:-ml-1" inline="true"></ic-icon>
      </button>
    }
  </div>

  <!-- Navigation (PrimeNG Menubar) – aligned like Designflow (left) and icons (right) -->
  @if ((isVerticalLayout$ | async) && (isNavbarInToolbar$ | async) && !mobileQuery) {
    <div
      class="vex-toolbar-nav">
      <vex-navigation [inToolbar]="true"></vex-navigation>
    </div>
  }

  <!-- Spacer -->
  <span class="flex-1"></span>

  <!-- Right side actions -->
  <div class="-mx-1 flex items-center flex-shrink-0">
    <div class="px-1" style="position: relative; display: inline-flex;">
      <button mat-icon-button
        type="button"
        matTooltip="Notifications"
        (click)="navigateToNotifications()">
        <mat-icon class="icon-animate icon-animate-shake" aria-label="Notifications">notifications</mat-icon>
      </button>
      @if ((unreadCount$ | async); as count) {
        @if (count > 0) {
          <span style="
            position: absolute;
            top: 4px; right: 4px;
            min-width: 16px; height: 16px;
            padding: 0 4px;
            border-radius: 8px;
            background: #e53935;
            color: #fff;
            font-size: 10px;
            font-weight: 700;
            line-height: 16px;
            text-align: center;
            pointer-events: none;
          ">{{ count > 99 ? '99+' : count }}</span>
        }
      }
    </div>
    <div class="px-1">
      <button mat-icon-button
        type="button"
        matTooltip="Quick actions for managing item data, customizing your view, and controlling the list display"
        (click)="toggleToolbar()">
        <mat-icon class="icon-animate icon-animate-wiggle" aria-label="Toggle toolbar">dashboard_customize</mat-icon>
      </button>
    </div>
    <div class="px-1">
      <button #themeBtn
        mat-icon-button
        type="button"
        matTooltip="Customize grid"
        (click)="openThemeDialog()">
        <mat-icon class="icon-animate icon-animate-rotate" aria-label="Customize grid">tune</mat-icon>
      </button>
    </div>


<!-- Build version badge -->
    <div class="px-2 flex flex-col items-end leading-none"
         style="font-size:10px; opacity:0.55; white-space:nowrap;">
      <span style="font-family:monospace; letter-spacing:0.04em;">{{ appVersion.commitHash }}</span>
      <span>{{ appVersion.pushedAt }}</span>
    </div>

    <div class="px-1">
      <vex-toolbar-user></vex-toolbar-user>
    </div>

    <!-- Language menu (hidden for now) -->
    <mat-menu style="visibility: hidden;" #languageMenu="matMenu" overlapTrigger="false" xPosition="before" yPosition="below">
      <button mat-menu-item>
        <iconify-icon [icon]="emojioneUS" width="24" height="24"></iconify-icon>
        <span>English</span>
      </button>
      <button mat-menu-item>
        <iconify-icon [icon]="emojioneDE" width="24" height="24"></iconify-icon>
        <span>German</span>
      </button>
    </mat-menu>
  </div>
</div>

<!-- Navbar below toolbar (PrimeNG Menubar) -->
@if ((isVerticalLayout$ | async) && (isNavbarBelowToolbar$ | async) && !mobileQuery) {
  <vex-navigation>
  </vex-navigation>
}
